import React, { useState } from "react";
import {
  Box,
  VStack,
  HStack,
  Text,
  Collapse,
  useDisclosure,
} from "@chakra-ui/react";

const CollapsibleSection = ({ title, children, defaultIsOpen = true }) => {
  const { isOpen, onToggle } = useDisclosure({ defaultIsOpen });

  return (
    <Box
      bg="white"
      borderRadius="4px"
      boxShadow="0px 4px 8px 0px rgba(208, 204, 213, 0.16), 0px 0px 4px 0px rgba(208, 204, 213, 0.08)"
      w="full"
    >
      <VStack spacing={0} align="stretch">
        {/* Header */}
        <Box p={3}>
          <VStack spacing="11px" align="stretch">
            {/* Title with toggle line */}
            <VStack spacing={0} align="stretch">
              <Text
                fontSize="12px"
                fontWeight="84"
                lineHeight="1.5"
                letterSpacing="-0.01em"
                color="#000000"
                fontFamily="Geist, sans-serif"
                cursor="pointer"
                onClick={onToggle}
              >
                {title}
              </Text>

              {/* Horizontal line */}
              <Box
                w="full"
                h="0px"
                borderTop="1px solid"
                borderColor="rgba(208, 204, 213, 0.3)"
                mt="11px"
              />
            </VStack>

            {/* Collapsible Content */}
            <Collapse in={isOpen} animateOpacity>
              <Box pt="11px">{children}</Box>
            </Collapse>
          </VStack>
        </Box>
      </VStack>
    </Box>
  );
};

export default CollapsibleSection;
